import { redirect } from "@tanstack/react-router";
import type { SessionUser } from "../store/auth";
import { ADMIN_ROLE } from "./constants";

// The admin rule lives here, in one place. useIsAdminUser (server.helpers.ts),
// and through it plain <AdminOnly>, delegates to isAdminRole. Every /admin
// entry point in the UI sits behind plain <AdminOnly>, so the guard locks out
// nobody who reaches those pages today.
// It is UX, not authorization: the session user comes from localStorage, and
// the backend still has to enforce roles.
export function isAdminRole(
  user: Pick<SessionUser, "Role"> | null | undefined
): boolean {
  return user?.Role === Number(ADMIN_ROLE.value);
}

export function requireAdminRole({
  context,
}: {
  context: { auth: { user: Pick<SessionUser, "Role"> | null } };
}): void {
  if (!isAdminRole(context.auth.user)) {
    throw redirect({ to: "/home" });
  }
}

// Students (role 3) have their own apps. The backend refuses them on every
// teacher endpoint, so admitting one here would only show a broken app.
export function canUseTeacherTool(user: Pick<SessionUser, "Role">): boolean {
  return user.Role === 1 || user.Role === 2;
}
